var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input } from '@angular/core';
import { NavController } from 'ionic-angular';
import { ApiProvider } from '../../providers/api/api';
import { CommonProvider } from '../../providers/common/common';
var RssComponent = /** @class */ (function () {
    function RssComponent(navCtrl, apiProv, comProv) {
        this.navCtrl = navCtrl;
        this.apiProv = apiProv;
        this.comProv = comProv;
        this.rss_data = [];
        this.feed_list = [];
        this.grids = [];
        this.number_column = 2;
        this.number_row = 1;
        this.col_24 = null;
        this.col_32 = null;
        this.col_48 = true;
        this.col_96 = null;
        this.slide_config = { perview: 2 };
    }
    RssComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        var rss_id = changes['rss_id'].currentValue;
        this.text = rss_id;
        if (!rss_id) {
            return;
        }
        this.display_rss_id = 'display_rss_id_' + rss_id + '_' + new Date().getTime();
        this.rss_data = this.comProv.getRssData(rss_id);
        if (!this.rss_data['feed_url']) {
            return;
        }
        if (this.rss_data['number_column']) {
            this.number_column = this.rss_data['number_column'];
        }
        if (this.rss_data['number_row']) {
            this.number_row = this.rss_data['number_row'];
        }
        if (this.number_column == 1) {
            this.col_24 = null;
            this.col_32 = null;
            this.col_48 = null;
            this.col_96 = true;
        }
        else if (this.number_column == 3) {
            this.col_24 = null;
            this.col_32 = true;
            this.col_48 = null;
            this.col_96 = null;
        }
        else if (this.number_column == 4) {
            this.col_24 = true;
            this.col_32 = null;
            this.col_48 = null;
            this.col_96 = null;
        }
        this.slide_config['perview'] = this.rss_data['number_column'];
        if (this.rss_data['css']) {
            var css = this.rss_data['css'].replace(/.rss_css/g, '.' + this.display_rss_id + ' ');
            var style = document.createElement('style');
            style.textContent = css;
            document.head.appendChild(style);
        }
        if (!this.rss_data['is_use_bearer_token']) {
            this.getFeed();
        }
        setTimeout(function () {
            var parent_el;
            var marker_el;
            var rss_el;
            var rss_child_el = document.querySelector('.' + _this.display_rss_id);
            if (rss_child_el) {
                rss_el = rss_child_el.parentNode;
            }
            if (_this.page_name == 'home') {
                parent_el = document.querySelector('#topmenu');
                var rss_row_els = document.getElementsByClassName('rss-row');
                if (rss_row_els) {
                    for (var i = 0; i < rss_row_els.length; i++) {
                        if (rss_row_els[i].getAttribute('rss_id') == rss_id) {
                            marker_el = rss_row_els[i];
                            break;
                        }
                    }
                }
            }
            else if (_this.page_name == 'sanitizer') {
                var parent_els = document.getElementsByClassName('parent_rss');
                if (parent_els) {
                    for (var i = 0; i < parent_els.length; i++) {
                        if (parent_els[i].getAttribute('rss_id') == rss_id) {
                            parent_el = parent_els[i];
                            marker_el = parent_els[i].querySelector('.marker_rss');
                        }
                    }
                }
            }
            if (parent_el && marker_el && rss_el) {
                parent_el.insertBefore(rss_el, marker_el);
                marker_el.innerHTML = '';
            }
        }, 1);
    };
    RssComponent.prototype.getTokenFeed = function () {
        if (!this.rss_data['is_use_bearer_token']) {
            return;
        }
        this.getFeed();
    };
    RssComponent.prototype.getFeed = function () {
        var _this = this;
        this.apiProv.getFeed(this.rss_data['feed_url'], null, this.rss_data['is_use_bearer_token'])
            .then(function (data) {
            if (!data) {
                return;
            }
            var parser = new DOMParser();
            var xml_doc = parser.parseFromString(data, 'text/xml');
            if (!xml_doc) {
                return;
            }
            var item = xml_doc.getElementsByTagName('item');
            // 表示数
            var max_length = 20;
            if (_this.rss_data['display_type'] == 0) {
                max_length = _this.number_column * _this.number_row;
            }
            else if (_this.rss_data['display_type'] == 2) {
                max_length = _this.number_row;
            }
            if (item.length < max_length) {
                max_length = item.length;
            }
            // オプション表示
            var option_tags = [];
            if (_this.rss_data['option_tag']) {
                option_tags = _this.rss_data['option_tag'].split('+');
            }
            for (var i = 0; i < max_length; i++) {
                var feed_data = {};
                var title = _this.getNodeValue(item[i], 'title');
                var format_date = void 0;
                if (_this.rss_data['is_display_date']) {
                    format_date = _this.getNodeValue(item[i], 'pubDate');
                }
                var image_url = void 0;
                if (item[i].getElementsByTagName('enclosure')[0]) {
                    image_url = item[i].getElementsByTagName('enclosure')[0].getAttribute('url');
                }
                else if (item[i].getElementsByTagName('media:content')[0]) {
                    image_url = item[i].getElementsByTagName('media:content')[0].getAttribute('url');
                }
                var option = void 0;
                if (_this.rss_data['option_tag']) {
                    var option_el = item[i];
                    for (var j = 0; j < option_tags.length; j++) {
                        var option_tag = option_tags[j];
                        if (!option_el.getElementsByTagName(option_tag)[0]) {
                            break;
                        }
                        if (j + 1 >= option_tags.length) {
                            option = _this.getNodeValue(option_el, option_tag);
                            break;
                        }
                        else {
                            option_el = option_el.getElementsByTagName(option_tag)[0];
                        }
                    }
                }
                var link = _this.getNodeValue(item[i], 'link');
                feed_data['title'] = title;
                feed_data['format_date'] = format_date;
                feed_data['image_url'] = image_url;
                feed_data['option'] = option;
                feed_data['link_url'] = link;
                _this.feed_list[i] = feed_data;
            }
            _this.grids = _this.setGrid(_this.feed_list);
        }).catch(function (error) {
            console.log('error', error);
        });
    };
    RssComponent.prototype.setGrid = function (list) {
        var grid = [];
        for (var i = 0; i < list.length; i += this.number_column) {
            var row = list.slice(i, i + this.number_column);
            grid.push(row);
        }
        return grid;
    };
    RssComponent.prototype.getNodeValue = function (element, tag_name) {
        var node_value;
        if (!element.getElementsByTagName(tag_name)[0]) {
            return node_value;
        }
        if (!element.getElementsByTagName(tag_name)[0].childNodes[0]) {
            return node_value;
        }
        node_value = element.getElementsByTagName(tag_name)[0].childNodes[0].nodeValue;
        if (tag_name == 'pubDate') {
            node_value = this.comProv.formatDate(new Date(node_value), 'YYYY/MM/DD');
        }
        return node_value;
    };
    RssComponent.prototype.goDetail = function (data) {
        if (!this.rss_data['is_link_detail']) {
            return;
        }
        if (!data['link_url']) {
            return;
        }
        this.comProv.checkLink(data['link_url'], this.navCtrl);
    };
    RssComponent.prototype.goAll = function () {
        if (!this.rss_data['all_link_url']) {
            return;
        }
        this.comProv.checkLink(this.rss_data['all_link_url'], this.navCtrl);
    };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], RssComponent.prototype, "rss_id", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], RssComponent.prototype, "page_name", void 0);
    RssComponent = __decorate([
        Component({
            selector: 'rss',
            templateUrl: 'rss.html'
        }),
        __metadata("design:paramtypes", [NavController,
            ApiProvider,
            CommonProvider])
    ], RssComponent);
    return RssComponent;
}());
export { RssComponent };
//# sourceMappingURL=rss.js.map


// WEBPACK FOOTER //
// ./src/components/rss/rss.ts.pre-build-optimizer.js